<script setup>
import { onMounted } from 'vue';
import debounce from 'lodash/debounce';

const resize = debounce((event) => {
  event.target.style.height = 'auto';
  event.target.style.height = `${event.target.scrollHeight}px`;
}, 300);

onMounted(() => {
  const element = document.querySelector('#content');
  if (element) {
    element.style.height = `${element.scrollHeight}px`;
  }
});
</script>

<template>
  <slot :resize="resize" />
</template>
